import { CategoryUnionType, useUpdatePersonPrivateInfo } from '@api';
import { useNotification } from '@common';
import type { FreelancerFormSchemaType } from '../../components/CompanyLinksModal/components/EditFreelancerForm/hooks';

const TRANS_KEY = 'NOTIFICATIONS.CREATE_FREELANCER';

type UseCreateFreelancerReturnType = {
  createFreelancer: (
    personId: string,
    data: FreelancerFormSchemaType,
    onSuccess?: () => void
  ) => Promise<void>;
};

export const useCreateFreelancer = (): UseCreateFreelancerReturnType => {
  const { mutateAsync } = useUpdatePersonPrivateInfo();
  const { showSuccess, showError } = useNotification();

  const createFreelancer = async (
    personId: string,
    data: FreelancerFormSchemaType,
    onSuccess?: () => void
  ) => {
    await mutateAsync(
      {
        id: personId,
        data: {
          freelancer: {
            ...data,
            categories: data.categories as CategoryUnionType[],
          },
        },
      },
      {
        onSuccess: () => {
          showSuccess({
            title: `${TRANS_KEY}.SUCCESS.TITLE`,
            message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
          });
          onSuccess?.();
        },
        onError: (error) => {
          showError({
            title: `${TRANS_KEY}.ERROR.TITLE`,
            message: `${TRANS_KEY}.ERROR.MESSAGE`,
            error,
          });
        },
      }
    );
  };

  return { createFreelancer };
};
